import { render, staticRenderFns } from "./AddJobPhaseModal.vue?vue&type=template&id=2c2b7ab1&scoped=true"
import script from "./AddJobPhaseModal.vue?vue&type=script&lang=js"
export * from "./AddJobPhaseModal.vue?vue&type=script&lang=js"
import style0 from "./AddJobPhaseModal.vue?vue&type=style&index=0&id=2c2b7ab1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2b7ab1",
  null
  
)

export default component.exports